import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useTheme from '../../hooks/useTheme';

// Iconos SVG filled modernos
const IcoDashboard  = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>);
const IcoTarjetas   = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>);
const IcoUsuarios   = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>);
const IcoRoles      = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>);
const IcoClientes   = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>);
const IcoPQR        = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"/></svg>);
const IcoFactura    = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>);
const IcoReportes   = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>);
const IcoSettings   = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/></svg>);
const IcoLogout     = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>);
const IcoMenuOpen   = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"/></svg>);
const IcoMenuClose  = () => (<svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/></svg>);

const Layout = ({ children }) => {
    const { user, logout, can } = useAuth();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    const isSuperAdmin = user?.role_slug === 'superadmin';
    const isAdmin      = user?.role_slug === 'admin';
    const isCliente    = user?.role_slug === 'cliente';

    const navItems = [
        { path: '/dashboard',    label: 'Dashboard',    icon: <IcoDashboard />,  show: true },
        { path: '/mis-tarjetas', label: 'Mis Tarjetas', icon: <IcoTarjetas />,   show: isCliente },
        { path: '/tarjetas',     label: 'Tarjetas NFC', icon: <IcoTarjetas />,   show: can('tarjetas', 'read') && !isCliente },
        { path: '/users',        label: 'Usuarios',     icon: <IcoUsuarios />,   show: can('usuarios', 'read') },
        { path: '/roles',        label: 'Roles',        icon: <IcoRoles />,      show: can('roles', 'read') },
        { path: '/clientes',     label: 'Clientes',     icon: <IcoClientes />,   show: can('clientes', 'read') },
        { path: '/pqr',          label: 'PQR',          icon: <IcoPQR />,        show: can('pqr', 'read') },
        { path: '/facturacion',  label: 'Facturación',  icon: <IcoFactura />,    show: can('facturacion', 'read') },
        { path: '/reportes',     label: 'Reportes',     icon: <IcoReportes />,   show: can('reportes', 'read') },
        { path: '/settings',     label: 'Configuración',icon: <IcoSettings />,   show: isSuperAdmin || isAdmin },
    ];

    const visibleItems = navItems.filter(item => item.show);

    const isActive = (path) => {
        if (path === '/dashboard') return location.pathname === '/dashboard';
        return location.pathname.startsWith(path);
    };

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="flex h-screen overflow-hidden" style={{ backgroundColor: 'var(--color-fondo)' }}>

            {/* Sidebar */}
            <aside className={`${sidebarOpen ? 'w-60' : 'w-16'} transition-all duration-300 flex flex-col flex-shrink-0 relative`}
                   style={{ backgroundColor: 'var(--color-primary)' }}>

                {/* Logo */}
                <div className={`flex items-center ${sidebarOpen ? 'justify-between px-4' : 'justify-center px-2'} py-4`}
                     style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                    {sidebarOpen && (
                        <div className="flex items-center gap-2 min-w-0 flex-1 mr-2">
                            {theme.empresa_logo ? (
                                <img src={theme.empresa_logo} alt="Logo" className="h-7 object-contain" />
                            ) : (
                                <span className="font-bold text-white text-sm truncate">{theme.empresa_nombre}</span>
                            )}
                        </div>
                    )}
                    <button onClick={() => setSidebarOpen(!sidebarOpen)}
                        className="w-8 h-8 flex items-center justify-center rounded-xl text-white/70 hover:text-white hover:bg-white/10 transition flex-shrink-0">
                        {sidebarOpen ? <IcoMenuOpen /> : <IcoMenuClose />}
                    </button>
                </div>

                {/* Nav */}
                <nav className="flex-1 py-3 overflow-y-auto">
                    {visibleItems.map(item => {
                        const active = isActive(item.path);
                        return (
                            <Link key={item.path} to={item.path}
                                className={`relative flex items-center mx-2 mb-0.5 px-3 py-2.5 rounded-xl text-sm transition-all ${
                                    active
                                        ? 'bg-white text-gray-800 font-semibold shadow-sm'
                                        : 'text-white/70 hover:text-white hover:bg-white/10'
                                } ${!sidebarOpen ? 'justify-center' : 'gap-3'}`}
                                title={!sidebarOpen ? item.label : undefined}>
                                <span className={`flex-shrink-0 ${active ? 'text-gray-700' : ''}`}
                                      style={{ color: active ? 'var(--color-primary)' : undefined }}>
                                    {item.icon}
                                </span>
                                {sidebarOpen && <span className="truncate">{item.label}</span>}
                            </Link>
                        );
                    })}
                </nav>

                {/* Footer usuario */}
                <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }} className="p-3">
                    {sidebarOpen ? (
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 border border-white/20">
                                {user?.foto_url ? (
                                    <img src={user.foto_url} alt="Foto" className="w-full h-full object-cover" />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-xs font-bold text-white bg-white/20">
                                        {user?.nombre?.charAt(0)}
                                    </div>
                                )}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs font-semibold text-white truncate">{user?.nombre}</p>
                                <p className="text-xs text-white/40 truncate">{user?.role}</p>
                            </div>
                            <button onClick={handleLogout} title="Cerrar sesión"
                                className="w-7 h-7 flex items-center justify-center rounded-lg text-white/50 hover:text-white hover:bg-red-500/30 transition flex-shrink-0">
                                <IcoLogout />
                            </button>
                        </div>
                    ) : (
                        <button onClick={handleLogout} title="Cerrar sesión"
                            className="w-full flex justify-center py-1 text-white/50 hover:text-white hover:bg-red-500/20 rounded-xl transition">
                            <IcoLogout />
                        </button>
                    )}
                </div>
            </aside>

            {/* Main */}
            <div className="flex-1 flex flex-col overflow-hidden">
                {/* Header */}
                <header className="bg-white border-b border-gray-100 px-5 py-3 flex items-center justify-between flex-shrink-0">
                    <h2 className="text-sm font-bold text-gray-700">
                        {visibleItems.find(i => isActive(i.path))?.label || 'Panel'}
                    </h2>
                    <div className="relative">
                        <button onClick={() => setUserMenuOpen(!userMenuOpen)}
                            className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900 py-1.5 px-3 rounded-xl hover:bg-gray-50 transition border border-transparent hover:border-gray-200">
                            <div className="w-6 h-6 rounded-full overflow-hidden flex-shrink-0">
                                {user?.foto_url ? (
                                    <img src={user.foto_url} alt="Foto" className="w-full h-full object-cover" />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-white text-xs font-bold rounded-full"
                                         style={{ backgroundColor: 'var(--color-primary)' }}>
                                        {user?.nombre?.charAt(0)}
                                    </div>
                                )}
                            </div>
                            <span className="hidden sm:inline text-sm font-medium text-gray-700">{user?.nombre}</span>
                            <svg viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 text-gray-400"><path d="M7 10l5 5 5-5z"/></svg>
                        </button>
                        {userMenuOpen && (
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-2xl shadow-lg border border-gray-100 z-50 overflow-hidden">
                                <div className="px-4 py-3 border-b border-gray-50">
                                    <p className="text-xs font-semibold text-gray-700 truncate">{user?.nombre} {user?.apellido}</p>
                                    <p className="text-xs text-gray-400 truncate">{user?.email}</p>
                                </div>
                                <Link to="/profile"
                                    className="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 transition"
                                    onClick={() => setUserMenuOpen(false)}>
                                    <IcoUsuarios /> Mi perfil
                                </Link>
                                <button onClick={handleLogout}
                                    className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 transition">
                                    <IcoLogout /> Cerrar sesión
                                </button>
                            </div>
                        )}
                    </div>
                </header>

                <main className="flex-1 overflow-auto p-5">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;
